import NotificationMixin from '@/Mixins/800/notification/notification.mixin';
import ConfirmModalHelper from '@/Helpers/confirmModal';
export default {
  data() {
    return {
      searchTitle: '',
      tableHeaders: [
        {
          text: 'تاریخ ثبت',
          value: 'creationDate',
          align: 'center',
          sortable: true,
        },
        {
          text: 'توضیحات',
          value: 'description',
          align: 'center',
          sortable: true,
        },
        {
          text: 'تاریخ انقضا',
          value: 'expirationDate',
          align: 'center',
          sortable: true,
        },
        {
          text: 'کاربر',
          value: 'user',
          align: 'center',
          sortable: true,
        },
        {
          text: 'وضعیت',
          value: 'status',
          align: 'center',
          sortable: true,
        },
        {
          text: 'عملیات',
          value: 'action',
          align: 'center',
          sortable: true,
        },
      ],
      selectedID: null,
      showDetailModal: false,
      confirmationType: null,
      // pagination: {
      //   Page: 1,
      //   PageSize: 10,
      // },
    };
  },
  mixins: [NotificationMixin, ConfirmModalHelper],

  methods: {
    closeDetailModal: function () {
      this.showDetailModal = false;
    },
    openDetailModal: function () {
      this.showDetailModal = true;
    },
    showNotificationDetail: function (id) {
      this.selectNotification(id);
      this.getNotification(id);
      this.openDetailModal();
    },
    addNewNotification: function () {
      this.$router.replace({ name: 'notification_cu_for_800' });
    },
    editNotification: function (id) {
      const routeObj = { name: 'notification_cu_for_800', query: { id } };
      this.$router.replace(routeObj);
    },
    selectNotification: function (id) {
      this.selectedID = id;
    },
    setConfirmationType: function (type) {
      this.confirmationType = type;
    },
    // wantToDeleteNotification: function (id) {
    //   this.selectNotification(id);
    //   this.setConfirmationType(0);
    //   this.showConfirmModal("حذف اعلان", "آیا از حذف این اعلان اطمینان دارید؟");
    // },
    wantToChangeNotificationStatus: function (status, id) {
      let confirmTxt = {
        title: '',
        msg: '',
      };
      switch (status) {
        case false:
          this.setConfirmationType(1);
          confirmTxt.title = 'فعال کردن اعلان';
          confirmTxt.msg = 'آیا از فعال کردن این اعلان اطمینان دارید';
          break;
        default:
          this.setConfirmationType(2);
          confirmTxt.title = 'غیر فعال کردن اعلان';
          confirmTxt.msg = 'آیا از غیر فعال کردن این اعلان اطمینان دارید';
          break;
      }
      this.showConfirmModal(confirmTxt.title, confirmTxt.msg, 5000);
      this.selectNotification(id);
    },
    onDeletingConfirmation: function () {
      this.deleteNotification(this.selectedID);
    },
    onConfirmation: function () {
      switch (this.confirmationType) {
        case 0:
          this.onDeletingConfirmation();
          break;
        default:
          this.changeStatus();
          break;
      }
      this.hideConfirmModal();
    },
    changeStatus: function () {
      switch (this.confirmationType) {
        case 2:
          this.deactiveNotification(this.selectedID);
          break;
        default:
          this.activeNotification(this.selectedID);
          break;
      }
    },
  },
  watch: {
    showDetailModal: function (currentVal) {
      if (!currentVal) this.notification = {};
    },
  },
};
